import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { Divider } from "@/components/General/Dropdown/components/divider";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    return (
        <>
            <div className={cn("tw:flex tw:justify-between")}>{children}</div>
            <Divider />
        </>
    );
};

export { Base };
